export const findChoiceById = (choices, id) => {
    if (!choices || !id) return undefined;
    return choices.find(choice => choice.id === id);
};
